import React, { createContext, useContext, ReactNode } from 'react';

interface ShopSearchContextValue {
  userLegacyId?: string;
}

const ShopSearchContext = createContext<ShopSearchContextValue | undefined>(
  undefined
);

export const ShopSearchProvider = ({
  userLegacyId,
  children,
}: {
  userLegacyId?: string;
  children: ReactNode;
}) => (
  <ShopSearchContext.Provider value={{ userLegacyId }}>
    {children}
  </ShopSearchContext.Provider>
);

export const useShopSearchContext = () => useContext(ShopSearchContext);
